import { defineStore } from 'pinia';
const STORE_NAME = 'notification';
export const useNotificationStore = defineStore(STORE_NAME, {
    state: () => ({
        message: '',
        title: '',
        isNewMessage: false,
        token: null,
    }),
    actions: {
        set({ title, message }) {
            this.title = title;
            this.message = message;
            this.isNewMessage = true;
        },
        get() {
            return { title: this.title, message: this.message };
        },
        getIsNewMessage() {
            return this.isNewMessage;
        },
        clearNewMessage() {
            this.isNewMessage = false;
            this.message = '';
            this.title = '';
        },
        setToken(token) {
            this.token = token;
        }
    },
    persist: false,
});
